//component for mill bar feeder

import { Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuiItemComponent } from '@ral/ui:aui/item';
import { StoryCardComponent } from '@storyteller/card';
import { StoryDescriptionComponent } from '@storyteller/description';
import { StoryImageComponent, StoryImageSourceComponent } from '@storyteller/image';
import { StoryTitleComponent } from '@storyteller/title';
import { hostBinding } from 'ngxtension/host-binding';
import { ROUTES_NAMES } from '../utils/routes';

@Component({
    selector: 'app-easy-lean-kit',
    imports: [
        StoryCardComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        AuiItemComponent,
        StoryImageComponent,
        RouterLink,
        StoryImageSourceComponent,
    ],
    template: `
        <story-card>
            <story-image
                [fetchPriority]="'low'"
                class="@lg:aspect-[579/386] block aspect-[360/240]"
                alt="Easy lean kit"
            >
                <story-source [src]="'assets/images/easy-lean-kit.jpg'" [width]="360" [height]="240" />
                <story-source
                    [src]="'assets/images/easy-lean-kit.jpg'"
                    [width]="579"
                    [height]="386"
                    media="(min-width: 32rem)"
                />
            </story-image>

            <story-title [headingLevel]="3" className="@lg:story-font-headline2 story-font-headline3"
                >Easy lean kit</story-title
            >
            <story-description [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-16 leading-[1.5]'">
                Chytrý systém pro stabilní upnutí více dílů a&nbsp;plynulý chod CNC stroje.
            </story-description>

            <a
                auiItem
                [size]="'40'"
                [color]="'primary'"
                [fullWidth]="true"
                [attr.data-testid]="'story-button'"
                class="@lg:max-w-[268px] flex-none"
                [routerLink]="['/', routeName]"
                [ariaLabel]="'Prohlédnout produkt na stránce Easy lean kit'"
            >
                <span auiItemLabel>Prohlédnout produkt</span>
            </a>
        </story-card>
    `,
})
export class EasyLeanKitComponent {
    routeName = ROUTES_NAMES.easyLeanKit;
    hostClass = hostBinding(
        'class',
        computed(() => 'block h-full w-full')
    );
}
